export class FormCancelBookingOracle {
    constructor() {
        const buttons = document.querySelectorAll('.cancelBookingForm');

        buttons.forEach((button)=>{
            button.addEventListener('click', (e) =>{
                let {objectId, date, hourFrom, hourTo, eventId} = button.dataset;

                document.querySelector(`[name="objectID"]`).value = objectId;
                document.querySelector(`[name="eventID"]`).value = eventId;

                this.setValue('hourFrom',hourFrom);
                this.setValue('hourTo',hourTo);
                this.setValue('date',date);
            });
        })
    }

    setValue(select, value){
        document.querySelector(`[name="${select}"]`).value = value;
        document.querySelector(`#${select}`).innerHTML = value;
    }
}